import { Link, usePage } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import Heading from "@/components/heading"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { cn } from "@/lib/utils"
import {
  settingsAppearancePath,
  settingsEmailPath,
  settingsNotificationsPath,
  settingsPasswordPath,
  settingsPrivacyPath,
  settingsProfilePath,
  settingsSessionsPath,
} from "@/routes"
import type { NavItem } from "@/types"

const sidebarNavItems: NavItem[] = [
  {
    title: "Perfil",
    href: settingsProfilePath(),
    icon: null,
  },
  {
    title: "Email",
    href: settingsEmailPath(),
    icon: null,
  },
  {
    title: "Contraseña",
    href: settingsPasswordPath(),
    icon: null,
  },
  {
    title: "Notificaciones",
    href: settingsNotificationsPath(),
    icon: null,
  },
  {
    title: "Privacidad",
    href: settingsPrivacyPath(),
    icon: null,
  },
  {
    title: "Sesiones",
    href: settingsSessionsPath(),
    icon: null,
  },
  {
    title: "Apariencia",
    href: settingsAppearancePath(),
    icon: null,
  },
]

export default function SettingsLayout({ children }: PropsWithChildren) {
  const { url } = usePage()

  return (
    <div className="px-4 py-6">
      <Heading
        title="Configuración"
        description="Administra tu perfil y configuración de cuenta"
      />

      <div className="flex flex-col space-y-8 lg:flex-row lg:space-y-0 lg:space-x-12">
        <aside className="w-full max-w-xl lg:w-48">
          <nav className="flex flex-col space-y-1 space-x-0">
            {sidebarNavItems.map((item) => (
              <Button
                key={item.href}
                size="sm"
                variant="ghost"
                asChild
                className={cn("w-full justify-start", {
                  "bg-muted text-white": url === item.href,
                })}
              >
                <Link href={item.href} prefetch>
                  {item.title}
                </Link>
              </Button>
            ))}
          </nav>
        </aside>

        <Separator className="my-6 md:hidden" />

        <div className="flex-1 md:max-w-2xl">
          <section className="max-w-xl space-y-12">{children}</section>
        </div>
      </div>
    </div>
  )
}
